import { apiClient } from '../../app/api';

export interface DashboardSummary {
  productCount: number;
  orderCount: number;
  pendingOrders: number;
  completedOrders: number;
  cancelledOrders: number;
  totalRevenueCents: number;
}

export interface TenantSummaryRow {
  tenantId: number;
  slug: string;
  name: string;
  summary: DashboardSummary;
}

export function listTenantSummaries(): Promise<TenantSummaryRow[]> {
  return apiClient.get<TenantSummaryRow[]>('/operator/dashboard/tenants');
}
